<div class="mm-so" *ngIf="open" (click)="close()">
  <div class="mm-so-panel" (click)="$event.stopPropagation()" role="dialog"
       [attr.aria-label]="lang.isArabic ? 'البحث في الموقع' : 'Site search'">

    <div class="mm-so-bar">
      <i class="fa fa-search mm-so-bar-icon" aria-hidden="true"></i>
      <input #searchInput type="text" class="mm-so-input" [(ngModel)]="term" (input)="onInput()"
             [placeholder]="lang.isArabic ? 'ابحث عن خدمات، مقالات، وظائف…' : 'Search services, articles, jobs…'"
             autocomplete="off" />
      <button type="button" class="mm-so-close" (click)="close()"
              [attr.aria-label]="lang.isArabic ? 'إغلاق' : 'Close'">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="mm-so-body">
      <!-- Idle hint -->
      <div class="mm-so-hint" *ngIf="!searched && !loading">
        {{ lang.isArabic ? 'اكتب حرفين على الأقل للبحث.' : 'Type at least two characters to search.' }}
      </div>

      <!-- Loading -->
      <div class="mm-so-hint" *ngIf="loading">
        {{ lang.isArabic ? 'جارٍ البحث…' : 'Searching…' }}
      </div>

      <!-- No results -->
      <div class="mm-so-hint" *ngIf="searched && !loading && total === 0">
        {{ lang.isArabic ? 'لا توجد نتائج مطابقة.' : 'No matching results.' }}
      </div>

      <!-- Results -->
      <div class="mm-so-results" *ngIf="!loading && total > 0">
        <div class="mm-so-group" *ngFor="let g of groups">
          <div class="mm-so-group-head">
            <i class="fa" [ngClass]="g.icon" aria-hidden="true"></i>
            <span>{{ lang.isArabic ? g.labelAr : g.labelEn }}</span>
          </div>
          <button type="button" class="mm-so-item" [class.active]="isActive(r)"
                  *ngFor="let r of g.items" (click)="go(r)" (mouseenter)="activeIndex = flatResults.indexOf(r)">
            <span class="mm-so-item-title">{{ r.titleEn | loc : r.titleAr : (lang.lang$ | async) }}</span>
            <span class="mm-so-item-excerpt" *ngIf="(r.excerptEn || r.excerptAr)">
              {{ r.excerptEn | loc : r.excerptAr : (lang.lang$ | async) }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="mm-so-foot">
      <span><kbd>↑</kbd><kbd>↓</kbd> {{ lang.isArabic ? 'تنقّل' : 'navigate' }}</span>
      <span><kbd>↵</kbd> {{ lang.isArabic ? 'فتح' : 'open' }}</span>
      <span><kbd>esc</kbd> {{ lang.isArabic ? 'إغلاق' : 'close' }}</span>
    </div>
  </div>
</div>
